export enum EppState {
    NotApplicable = 'NotApplicable',
    NotProcessed = 'NotProcessed',
    Processed = 'Processed',
}
